import i18n from 'simple-react-i18n'

// Statut de conformité qualité d'une unité, calculé côté back par UnitComplianceService et remonté
// dans le champ `compliance` de l'unité. Mêmes valeurs et mêmes teintes que dans l'observatoire.
export const LIMIT_EXCEEDED = 'LIMIT_EXCEEDED'
export const REFERENCE_EXCEEDED = 'REFERENCE_EXCEEDED'
export const COMPLIANT = 'COMPLIANT'
export const NO_RECENT_OPERATION = 'NO_RECENT_OPERATION'

export const COMPLIANCE_COLORS = {
    limitExceeded: '#f44336',
    referenceExceeded: '#ff9800',
    compliant: '#4caf50',
    noRecentOperation: '#9e9e9e',
}

export const getComplianceStatus = (compliance) => {
    switch (compliance) {
        case LIMIT_EXCEEDED:
            return { label: i18n.limitExceeded, color: COMPLIANCE_COLORS.limitExceeded }
        case REFERENCE_EXCEEDED:
            return { label: i18n.referenceExceeded, color: COMPLIANCE_COLORS.referenceExceeded }
        case COMPLIANT:
            return { label: i18n.compliant, color: COMPLIANCE_COLORS.compliant }
        case NO_RECENT_OPERATION:
            return { label: i18n.noRecentOperation, color: COMPLIANCE_COLORS.noRecentOperation }
        default:
            return undefined
    }
}
